import DIApi from './_diApi';

class InventoryCategoryAPI extends DIApi {
  constructor() {
    super();
  }
  controllerName = 'InventoryCategorys';
}

export default new InventoryCategoryAPI();
